import { render, staticRenderFns } from "./HomeNav.vue?vue&type=template&id=bb354590&scoped=true"
import script from "./HomeNav.vue?vue&type=script&lang=js"
export * from "./HomeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb354590",
  null
  
)

export default component.exports